"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const FullScreenOn = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 13,
  height: 13,
  viewBox: "0 0 13 13"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M0.0527344 0.729309H4.75573V2.29698H1.6204V5.43231H0.0527344V0.729309ZM7.89107 0.729309H12.5941V5.43231H11.0264V2.29698H7.89107V0.729309ZM1.6204 8.56764V11.703H4.75573V13.2706H0.0527344V8.56764H1.6204ZM12.5941 8.56764V13.2706H7.89107V11.703H11.0264V8.56764H12.5941Z",
  className: "fill"
}));

var _default = FullScreenOn;
exports.default = _default;